// Keys ougt to be sorted alphabetically, case sensitive.
// To autosort: repeat CTRL+S until all keys are sorted
//  OR
// repeat command until sorted: npm run lint-fix

/* eslint sort-keys-fix/sort-keys-fix: error */
export default {
  accesslog: {
    accessedAt: 'Accessed at',
    accessedBy: 'Accessed by',
    accessedResource: 'Accessed resource',
    ip: 'IP',
    parameters: 'Parameters'
  },
  ban: {
    bannedAt: 'Banned at (UTC)',
    bannedUntil: 'Banned until (UTC)'
  },
  common: {
    active: 'Active',
    add: 'Add',
    address: 'Address',
    addressee: 'Addressee',
    articleNumber: 'Article number',
    back: 'Back',
    bankAccountBIC: 'BIC',
    bankName: 'Bank',
    barcodePrefix: 'Barcode prefix',
    barcodeType: 'Barcode type',
    bdo: 'BDO',
    billingAddress: 'Billing address',
    billingEmail: 'Billing Email address',
    block_notification_not_saved_warning: 'Notification setting not saved. Please try again later.',
    browserNotSupported: 'Your browser does not support this feature',
    businessRegisterNumber: 'Business register number',
    cancel: 'Cancel',
    city: 'City',
    clearFilters: 'Clear all filters',
    clientSales: 'Client sales GL',
    close: 'Close',
    close_unsaved_warning: 'You have unsaved changes. Are you sure you want to close this window?',
    code: 'Code',
    company: 'Company',
    companyAddress: 'Company address',
    companyEmail: 'Email address',
    confirm: 'Confirm',
    continue: 'Continue',
    copy: 'Copy',
    copyToClipboard: 'Copy to clipboard',
    copyToClipboardFail: 'Copy to clipboard failed',
    copyToClipboardSuccess: 'Copied to clipboard',
    country: 'Country',
    createReport: 'Create report',
    createdAt: 'Created on',
    creditorNumber: 'Creditor number',
    currency: 'Currency',
    data_created: 'The data has been saved',
    data_save_error: 'The data could not be be saved',
    data_updated: 'The changes are saved',
    date: 'Date',
    debtorNumber: 'Debtor number',
    decimals: 'Decimals',
    defaultBottomFinishID: 'Default bottom hem',
    defaultBottomFinishMeasurementInCm: 'Default bottom hem size (cm)',
    defaultEmbraceFinishID: 'Default tie-back',
    defaultExtraFinishID: 'Default extra',
    defaultLiningBottomFinishID: 'Lining bottom hem',
    defaultLiningBottomFinishMeasurementInCm: 'Lining bottom hem size (cm)',
    defaultSideFinishID: 'Default side hem',
    defaultSideFinishMeasurementInCm: 'Default side hem size (cm)',
    defaultTopFinishID: 'Default top finish',
    defaultTopFinishMeasurementInCm: 'Default top finish size (cm)',
    delete: 'Delete',
    deletePlural: 'Delete',
    delete_cancelled: 'Delete cancelled',
    delete_completed: 'Delete completed',
    delete_record_summary_warning: 'Are you sure you want to delete <b>{summary}</b>?',
    delete_record_warning: 'Are you sure you want to delete this?',
    department: 'Department',
    description: 'Description',
    domain: 'Domain',
    domains: 'Domains',
    dontSave: "Don't save",
    dontSend: "Don't send",
    dont_show_again_warning: 'Never ask again',
    downloadExcel: 'Download Excel',
    downloadPDF: 'Download PDF',
    draft: 'Draft',
    ean: 'EAN-13',
    edit: 'Edit',
    email: 'Email address',
    emptyString: ' ',
    endDate: 'End date',
    error: 'Error',
    exactInstance: 'Exact',
    excludedFinishes: 'Excluded finishes',
    export: 'Export',
    fabric: 'Fabric',
    fabricProduct: 'Fabric type',
    fabricType: 'Fabric type',
    fabricWidth: 'Fabric width',
    fabrics: 'Fabrics',
    fax: 'Fax',
    fillInANumber: 'Enter a number',
    finish: 'Finish',
    finishType: 'Finish type',
    firstName: 'First name',
    fixedPhone: 'Fixed phone',
    from: 'from',
    gender: 'Gender',
    general: 'General',
    glAccountNumber: 'General ledger number',
    glAccountNumbers: 'General ledger numbers',
    globalLocationNumber: 'GLN',
    houseNumber: 'House number',
    iban: 'IBAN',
    id: 'ID',
    inactive: 'Inactive',
    initials: 'Initials',
    intercompanySales: 'IC sales GLs',
    invoiceAddress: 'Invoice address',
    ipPddress: 'IP address',
    jobFunction: 'Job function',
    key: 'Key',
    label: 'Label',
    lastName: 'Last name',
    leave_mail_warning: 'You are about to leave this page. Do you want to send the email before leaving?',
    leave_unsaved_warning: 'You are about to leave this page. Do you want to save changes',
    lineNumber: 'Line number',
    lining: 'Lining',
    loading: 'Loading ...',
    mailingAddress: 'Mailing address',
    measurement: 'Measurement',
    measurements: 'Measurements',
    meter: 'meter',
    mobilePhone: 'Mobile phone',
    modifiedAt: 'Modified on',
    name: 'Name',
    no: 'No',
    notApplicable: 'Not applicable',
    notApplicableAbbr: 'n/a',
    number: 'Number',
    off: 'Off',
    ok: 'OK',
    on: 'On',
    order: 'Order',
    order_processed: 'Order processed successfully ',
    orders: 'Orders',
    otherPrintClients: 'Other',
    page: 'Page',
    palletNumber: 'Pallet number',
    parcelType: 'Parcel type',
    password: 'Password',
    phone: 'Phone',
    plannedWorkshopPrintClient: 'Workshop as planned',
    postalCode: 'Postal code',
    prefill: 'Prefill',
    prefix: 'Prefix',
    price: 'Price',
    priceListItem: 'Price list item',
    printers: 'Printers',
    priority: 'Priority',
    product: 'Product',
    productGroup: 'Product group',
    productType: 'Product type',
    publish: 'Publish',
    readMore: 'Read more ...',
    remark: 'Remark',
    remarks: 'Remarks',
    required: 'Required',
    returnOrder: 'Return order',
    save: 'Save',
    saveClose: 'Save & close',
    saveNext: 'Save & next',
    search: 'Search',
    selectPrinter: 'Select destination for printing',
    selectPrinterConfirm: 'Select',
    send: 'Send',
    series: 'Series',
    service: 'Service',
    shipmentList: 'Shipment list',
    standard: 'Default',
    startDate: 'Start date',
    status: 'Status',
    stay: 'Stay on page',
    stockLocation: 'Stock location',
    stockLocations: 'Stock locations',
    stockUnit: 'Stock unit',
    store: 'Store',
    stores: 'Stores',
    streetName: 'Street',
    streetNumber: 'Number',
    success: 'Success',
    supplier: 'Supplier',
    switchOff: 'Off',
    switchOn: 'On',
    tabDetails: 'Details',
    tabGeneral: 'General',
    taskstatus: 'Task status',
    ticketBarcode: 'Ticket barcode',
    ticketBarcodeNotFound: 'Ticket barcode not found',
    till: 'till',
    title: 'Title',
    to: 'To',
    total: 'Total',
    transport: 'Transport',
    type: 'Type',
    unit: 'Unit',
    username: 'Username',
    value: 'Value',
    vatNumber: 'VAT number',
    warning: 'Warning',
    week: 'Week',
    weeks: 'Weeks',
    workshop: 'Workshop',
    workshopPrintClients: 'Workshops',
    workshops: 'Workshops',
    yarn: 'Yarn',
    year: 'Year',
    yes: 'Yes'
  },
  company: {
    administrationNumber: 'Administration number',
    clientSalesJournalCode: 'Client sales journal code',
    exact: 'Exact',
    exactServerName: 'Server name',
    fiscalUnit: 'Fiscal unit',
    intercompanySalesJournalCode: 'Intercompany sales journal code',
    intrastatReporting: 'Intrastat reporting',
    logo: 'Logo',
    purchaseJournalCode: 'Purchase journal code',
    purchaseJournalType: 'Purchase journal type',
    remarkInvoice: 'Remark invoice',
    salesJournalType: 'Sales journal type'
  },
  componentList: {
    amountReturn: 'Returns',
    extras: 'Extras',
    lined: 'Lined',
    metersAmount: 'Amount of meters',
    panelsAmount: 'Amount of panels',
    piecesAmount: 'Amount of pieces',
    product: 'Component',
    productType: 'Producttype',
    romanBlindsAmount: 'Amount of roman blinds',
    total: 'Total',
    totals: 'Totals',
    unlined: 'Unlined',
    weeks: 'Weeks'
  },
  configuration: {
    code: 'Code',
    fromDate: 'Valid from',
    value: 'Value'
  },
  country: {
    eu: 'European Union'
  },
  currency: {
    isoCode: 'ISO code',
    symbol: 'Symbol'
  },
  domain: {
    all: 'My domains',
    allowDuplicateStoreCodes: 'Duplicate store codes allowed',
    apiKey: 'API key',
    autoProcessFabricOrders: 'Automatically stock fabric orders',
    barcodePrefix: 'Barcode prefix',
    calculateOrderLinesForInteriorDecorator: 'Calculate order line details interior decorator',
    chooseDomain: 'Select a domain',
    company: 'Company',
    copyDataFromDomain: 'Copy data from',
    createFabrics: 'Create fabrics',
    culture: 'Culture',
    cultures: 'Cultures',
    defaultDeliverAtHomeYN: 'Default home delivery',
    deliveryPrice: 'Delivery price',
    deliveryPrices: 'Delivery prices',
    distributionCenter: 'Distribution center',
    domainCode: 'Code domain',
    domainDescription: 'Description domain',
    export: 'Export invoices via',
    familyOrderPacking: 'Family order packing',
    houseNumberValidationDisabled: 'House number validation disabled',
    invalidFinishCombinations: 'Invalid finish combinations',
    invoiceName: 'Name on invoice',
    invoicePer: 'Invoice per',
    keepCalculatedValuesOnReturnOrder: 'Return order keep calculations',
    lastStockWorkshop: 'Workshop for last stock',
    nameOnTicket: 'Name on ticket',
    noData: 'No domains are known',
    orderNumberPrefix: 'Order number prefix',
    paymentDiscountPercentage: 'Payment discount (%)',
    paymentTermDays: 'Payment term (days)',
    priceDescription: 'Gekoppelde prijs',
    productGroup: 'Product group settings',
    productGroupFinishApplicable: 'Available for this client',
    productGroupFinishes: 'Customer-specific finishes',
    productGroupPrices: 'Prices',
    productGroupSettings: '{domainName} - Settings for product group {productGroup}',
    quarterPanels: 'Quarter panels',
    rfidEnabledYN: 'RFID',
    rfidPrefix: 'RFID prefix',
    shareHalfPanels: 'Share half panels',
    showOrdersInvoicePer: 'Invoice show orders per',
    standardDeliveryPeriod: 'Standard delivery period in days',
    storeAttributes: 'Store attributes',
    storeTypes: 'Store types',
    stores: 'Stores',
    stripCorrection: 'Strip correction (panels)',
    tabContactPersons: 'Contact persons',
    tabGeneral: 'General',
    tabProducts: 'Products',
    tabSettings: 'Settings',
    ticketLanguage: 'Language on ticket',
    transportOrderMultipleWorkshops: 'Multiple workshops per shipment list'
  },
  draftTool: {
    black: 'Black',
    chrome: 'Chrome',
    electric: 'Electric',
    fixtureGrommets: 'Rings',
    fixturePole: 'Pole',
    fixtureRail: 'Rail',
    fixtureTabTop: 'Tab top',
    fixtureTunnelAtTop: 'Tunnel at top',
    fixtureTunnelAtTopAndBottom: 'Tunnel at top and bottom',
    fixtureWaveCurtain: 'Wave curtain',
    hemDouble: 'Double',
    hemNone: 'None',
    hemSingle: 'Single',
    left: 'Left',
    manual: 'Manual',
    piecesBoth: 'Two pieces',
    piecesLeft: 'Piece left',
    piecesRight: 'Piece right',
    pleatDouble: 'Double pleat',
    pleatDoubleReturn: 'Double with return pleat',
    pleatFlat: 'Flat pleat',
    pleatSingle: 'Single pleat',
    pleatSingleReturn: 'Single with return pleat',
    pleatTriple: 'Triple pleat',
    pleated: 'Pleated',
    pleatingTape: 'Pleating tape',
    productGroupCurtain: 'Panel curtain',
    productGroupLaces: 'Laces',
    productGroupRomanBlind: 'Roman blind',
    productGroupRoomHighCurtain: 'Ceiling-high curtain',
    productGroupTieBack: 'Tie-back',
    right: 'Right',
    setFromBottom: 'Set from bottom',
    setFromTop: 'Set from top',
    setNone: 'No set',
    tape: 'Tape',
    tbd: 'TBD',
    tieBackBanana: 'Banana',
    tieBackNone: 'None',
    tieBackStraight: 'Straight',
    tight: 'Tight',
    tunnelBack: 'Tunnel back',
    tunnelFront: 'Tunnel front',
    white: 'White'
  },
  error: {
    general_request: 'Something went wrong. Try again later.',
    oneOrMoreInputs: 'Data could not be saved because there are errors in the form',
    save: 'Something went wrong. Try again later.'
  },
  errorLog: {
    description:
      'Now the management system are basically the form of the spa, it enhances the user experience, but it also increases the possibility of page problems, a small negligence may lead to the entire page deadlock. Fortunately Vue provides a way to catch handling exceptions, where you can handle errors or report exceptions.',
    documentation: 'Document introduction',
    tips: 'Please click the bug icon in the upper right corner'
  },
  errorPages: {
    backToHome: 'Back to home',
    headline401: "You don't have permission to go to this page",
    headline403: "You don't have permission to go to this page",
    headline404: 'Page not found',
    message401: 'If you do not agree with this, please contact your administrator.',
    message403: 'If you do not agree with this, please contact your administrator.',
    message404: 'Please check that the URL you entered is correct.',
    return: 'return',
    title401: 'Oops',
    title403: 'Access denied',
    title404: 'Sorry'
  },
  eventlog: {
    exception: 'Exception',
    level: 'Level',
    logger: 'Logger',
    message: 'Message',
    occurredAt: 'Occurred at',
    thread: 'Thread'
  },
  exactInstance: {
    serverName: 'Server name',
    serviceUrl: 'Service URL'
  },
  fabric: {
    actualWidth: 'Actual width (cm)',
    availableStock: 'Available stock',
    blackout: 'Blackout fabric',
    canBeLined: 'Can be lined',
    canBeUsedAsLiningForRomanBlindsYN: 'Can be used as lining for roman blinds',
    canBeUsedAsLiningYN: 'Can be used as lining',
    canBeUsedForRomanBlinds: 'Can be used for roman blinds',
    collections: 'Collections',
    consumerPrices: 'Consumer prices',
    containsWeightCord: 'Contains weight cord',
    cordProduct: 'Roman blind cord',
    createdAt: 'Created on',
    cuttingWastePercentage: 'Cutting waste (%)',
    description: 'Fabric name',
    discontinuationDate: 'Discontinuation date',
    domainProductCode: 'Article number',
    excludedWorkshops: 'Excluded workshops',
    fabricStatusOption: 'Status',
    fabricWidth: 'Fabric width (cm)',
    flawInWeavingPercentage: 'Flaw in weaving subdivision (%)',
    handlock: 'Handlock',
    hasPattern: 'Has pattern',
    ironYN: 'Iron',
    leftOverPercentage: 'Leftover subdivision (%)',
    liningCordProduct: 'Roman blind cord when used as lining',
    lockSeamWidth: 'Width lock seam (cm)',
    nap: 'Nap',
    noCordProductID: 'Unknown',
    nonDiverseLinings: 'Standard lining',
    partsPerHanger: 'Maximum number of parts per hanger',
    pattern: 'Pattern',
    patternHeight: 'Pattern height (mm)',
    posCode: 'POS code',
    preferredWorkshop: 'Preferred workshop',
    prices: 'Prices',
    productType: 'Fabric type',
    purchasePrice: 'Purchase price',
    romanBlindCanBeLinedYN: 'Roman blind can be lined',
    romanBlindCode: 'Roman blind code',
    romanBlindRibTypeOption: 'Fold rods',
    sellingPrice: 'Selling price',
    solid: 'Solid',
    sourceLinkDomainProductGroup: 'Domain specific',
    sourceProductGroup: 'Product group',
    staggeredPatternYN: 'Staggered pattern',
    stockCorrections: 'Mutations',
    stocks: 'Available stocks',
    tabDetails: 'Details',
    tabGeneral: 'General',
    takeOverFromProductGroupToolTip: 'from {productGroupName} ({sourceName})',
    takeOverFromSettingsToolTip: 'from settings ({settingsName})',
    washingInstructionProduct: 'Washing instructions',
    weightCordProduct: 'Weight cord',
    weightPerM2InG: 'Weight per m2 (g)',
    width: 'Width (cm)',
    yarn: 'Yarn'
  },
  fabricOrder: {
    actualDeliveryAt: 'Actual delivery date',
    createdAt: 'Created on',
    deliveredQuantity: 'Delivered (m)',
    domainName: 'Domain',
    estimatedDeliveryAt: 'Estimated delivery date',
    estimatedDepartureAt: 'Estimated departure date',
    externallyModifiedAt: 'Modified on',
    fabricOrderStatusOption: 'Status',
    feedbackError: 'Failed',
    feedbackOK: 'OK',
    feedbackSuccessYN: 'Feedback',
    feedbackUndefined: '-',
    orderLines: 'Order lines',
    orderNumber: 'Order number',
    orderedQuantity: 'Ordered (m)',
    stockLocationName: 'Stock location',
    supplierCode: 'Supplier number',
    supplierName: 'Supplier',
    tabGeneral: 'General',
    totalDeliveredQuantity: 'Delivered total (m)',
    totalQuantityDeliveredInMeters: 'Total delivered nr of m',
    totalQuantityOrderedInMeters: 'Ordered nr of m'
  },
  fabricStockReport: {
    availableStock: 'Available',
    blockedStock: 'Blocked',
    excelFileName: 'FabricStockReport',
    excelWorksheetName: 'stock',
    includeAvailableAmount: 'Available stock',
    includeBlockedAmount: 'Blocked stock',
    includePositionCode: 'Location code',
    includeReservedAmount: 'Work in progress stock',
    positionCode: 'Location',
    reservedStock: 'WIP',
    soldStock: 'Sold',
    stockLocations: 'Stock locations',
    stockReportData: 'Stock report',
    tabGeneral: 'Data selection',
    totalStock: 'Total'
  },
  fileUpload: {
    dragAndDropHtml: 'Drop file here or <em>click to upload</em>',
    uploadTip: 'Upload a file up to 2 MB'
  },
  finish: {
    applyPleatMachineCorrectionYN: 'Apply machine and laser correction',
    canBeExcludedDueToFabricYN: 'Fabric restrictions apply',
    canBeExcludedDueToWorkshopYN: 'Workshop restrictions apply',
    defaultProduct: 'Default product',
    extraFabricHeightFormula: 'Extra fabric height formula',
    extraFabricWidthFormula: 'Extra fabric width formula',
    fabricWidthFactor: 'Fabric width factor',
    finishMeasurementFabricFactor: 'Factor on the finish size',
    headingHeight: 'Heading height (cm)',
    hideQuantityOnTicket: 'Hide amount on ticket',
    maximumFabricWidthFactor: 'Upper limit fabric width factor',
    minimumFabricWidthFactor: 'Lower limit fabric width factor',
    parityOption: 'Parity',
    quantityFormula: 'Formula for amount',
    roundOption: 'Rounding',
    seperateSeriesYN: 'Separate series'
  },
  finishType: {
    calculationMethod: 'Calculation method',
    extraFabricHeightApplicable: 'Extra fabric height applicable',
    extraFabricWidthApplicable: 'Extra fabric width applicable',
    fabricWidthFactorRequired: 'Fabric width factor required',
    finishes: 'Finishes',
    measurementRequired: 'Measurement required',
    requiredProductType: 'Required product type'
  },
  forgotPassword: {
    description:
      'You can change your password for security reasons or reset it if you forget it. Complete the form below to get the instructions sent to your email',
    done: 'An email has been sent to {email}. Please check your email for instructions.',
    submit: 'Send email',
    title: 'Forgot password'
  },
  hemaPendingProject: {
    customerDebtorCode: 'Customer debtor code',
    customerDeliveryCode: 'Customer delivery code',
    customerName: 'Customer name',
    prjDate: 'Project date',
    prjNumber: 'Project number',
    sentDate: 'Sent date'
  },
  home: {
    orderLineStatusSummary: 'STATUS SUMMARY',
    quickSearch: 'QUICK SEARCH',
    welcomeVisitor: 'Welcome visitor'
  },
  interiorDecorator: {
    assemblyHeight: 'Assembly height (cm)',
    attachLeadCord: 'Attach lead cord',
    bananaTieback: 'Banana tie back',
    band: 'Tape (cm)',
    bottomHem: 'Bottom hem',
    bottomHemSize: 'Bottom hem size (cm)',
    brackets: 'Hooks',
    chain: 'Chain',
    cutSize: 'Cutting size (cm)',
    cutSizeLeft: 'Cutting size left (cm)',
    cutSizeRight: 'Cutting size right (cm)',
    duplicate: 'Duplicate',
    fabricTotal: 'Total fabric (cm)',
    fabricWidth: 'Fabric width (cm)',
    finish: 'Finish',
    fixture: 'Fixture',
    grommets: 'Colour & diameter',
    headingHeight: 'Header (cm)',
    height: 'Height (cm)',
    numberOfPanels: 'Panels',
    operatingSide: 'Operating side',
    operatingType: 'Operating type',
    panelsLeft: 'Panels left',
    panelsRight: 'Panels right',
    pieces: 'Number of pieces',
    pleat: 'Pleat',
    pleatingTapeSize: 'Pleating tape size (cm)',
    productType: 'Product type',
    railLength: 'Rail length (cm)',
    requiredFabric: 'Required fabric (cm)',
    ribs: 'Ribs',
    romanBlindSubtype: 'Roman blind type',
    set: 'Set',
    straightTieback: 'Straight tie back',
    system: 'System',
    tieBack: 'Tie back',
    tunnelPercentage: 'Fabric on rod',
    tunnelSize: 'Tunnel size (cm)',
    type: 'Type',
    waveSize: 'Distance runners (cm)',
    width: 'Width (cm)',
    widthLeft: 'Width left (cm)',
    widthRight: 'Width right (cm)'
  },
  invalidFinishCombination: {
    finish1: 'Finish 1',
    finish2: 'Finish 2'
  },
  inventory: {
    instruction:
      'Select a stock location and upload a CSV file. The file must have the following three columns: Domein;Artikelnummer;Vrij.',
    inventoryUpdated: 'Inventory was updated successfully',
    updateInventory: 'Update inventory'
  },
  invoice: {
    clientName: 'Client',
    details: 'Order summary',
    exportAccountingAt: 'Sent to finance',
    exportClientAt: 'Sent to client',
    externalInvoice: 'External invoice',
    internalInvoice: 'Internal invoice',
    invoiceDate: 'Invoice date',
    invoiceNumber: 'Invoice no.',
    invoiceType: 'Invoice type',
    invoicedInternallyYN: 'IC invoice',
    invoicesPrinted: 'The PDF(s) are created',
    month: 'Month',
    numberOfOrders: 'Orders',
    print: 'Print',
    purchaseInvoiceExportedOn: 'IC purchase invoice to Exact',
    salesInvoiceExportedOn: 'IC sales invoice to Exact',
    selectedInvoices: 'Invoices',
    storeCode: 'Store',
    summary: 'Invoice summary',
    totalAmountExcludingVAT: 'Total excl. VAT',
    totalAmountIncludingVAT: 'Total incl. VAT',
    year: 'Year'
  },
  invoiceSummary: {
    create: 'Create invoice summary',
    createDetailed: 'Create detailed invoice summary',
    from: 'From',
    to: 'to'
  },
  kwantum: {
    errorMessage: 'Error message',
    failedYN: 'Failed',
    m1_OrderNumberBuyer: 'M1 Order number buyer',
    m1_QueuedAt: 'M1 Processed on',
    m2_PolygonNumber: 'M2 Polygon number',
    m2_ProjectID: 'M2 Project ID',
    m2_PurchaseNumber: 'M2 Purchase number',
    m2_QueuedAt: 'M2 Processed on'
  },
  language: {
    code: 'ISO 639-1 Code'
  },
  linkPriceListItem: {
    blackoutYN: 'Blacked out',
    extraCostYN: 'Extra cost',
    finishesDescription: 'Finishes',
    priceListItem: 'Price list item',
    priceListItemDescription: 'Price list item description',
    selectedFinishes: 'Finishes'
  },
  login: {
    code: 'User name',
    forbidden: 'User/IP combination has been blocked.',
    logIn: 'Log in',
    password: 'Password',
    title: 'Log in',
    unauthorised: 'Login information is wrong',
    username: 'Username'
  },
  mail: {
    bcc: 'Bcc',
    body: 'Body',
    cc: 'Cc',
    error: 'An error has occured. Your e-mail was not sent.',
    from: 'From',
    subject: 'Subject',
    success: 'Your e-mail has been sent successfully.',
    to: 'To'
  },
  navbar: {
    dashboard: 'Dashboard',
    language: 'Language',
    logOut: 'Log Out',
    screenfull: 'Screenfull',
    size: 'Global Size',
    theme: 'Theme'
  },
  newPassword: {
    description: 'You can now permanently change your password.',
    done: 'Your password has successfully been changed.',
    invalidToken: 'This link has expired.',
    submit: 'Change password',
    title: 'New password'
  },
  order: {
    clientName: 'Client',
    consumerAddress: 'Consumer address',
    consumerDetails: 'Consumer details',
    consumerName: 'Consumer name',
    createSamples: 'Create samples',
    createdAt: 'Created on',
    finish: 'Finish up',
    internalRemarks: 'Internal remarks',
    orderNumber: 'Order number',
    orderStatus: 'Status',
    orderedAt: 'Order date',
    source: 'Source',
    storeName: 'Store',
    type: 'Type'
  },
  orderDraft: {
    addLine: 'Add line',
    bracketsExcluded: 'Excl. hooks',
    bracketsIncluded: 'Incl. hooks',
    calculating: 'Calculating cutting size and panels...',
    consumerData: 'Consumer data',
    draftSaved: 'Draft saved',
    leaveWithoutSaving: 'The order was not saved. Continue?',
    orderLineCount: 'Order lines',
    placeOrder: 'Place order',
    saveDraft: 'Save draft',
    send: 'Send',
    specials: 'Specials'
  },
  orderDraftValidation: {
    bottomHem: 'Bottom hem is required.',
    bottomHemSize: 'Bottom hem size is required.',
    colorAndDiameter: 'Color & diameter are required.',
    fabric: 'Fabric is required.',
    fabricWidth: 'The required fabric height is greater than the width of the fabric.',
    fixture: 'Fixture is required.',
    height: 'Height is required.',
    hooks: 'Hooks is required.',
    hooksDistance: 'Distance runners is required.',
    operatingSide: 'Operating side is required.',
    pleat: 'Pleat is required',
    pleatFactorPanel: 'Pleating factor is out of bounds. Please change the number of panels.',
    pleatFactorRoomHigh: 'Pleating factor is out of bounds. Please change the cutting size.',
    productGroup: 'Product type is required.',
    railLength: 'Rail length is required',
    romanBlindFabricWidth: 'Requested height is incompatible with fabric width.',
    tieBackType: 'Type is required.',
    tunnelPercentage: 'Fabric on rod is required.',
    tunnelSize: 'Tunnel size is required.',
    width: 'Width is required.'
  },
  orderLine: {
    actualDeliveryDate: 'Delivery date',
    alignPatternTopYN: 'B.O.P.',
    alignPatternYN: 'Align pattern',
    amount: 'Amount',
    assemblyHeight: 'Assembly height (cm)',
    bandMeasurementInCm: 'Band (cm)',
    bottomFinish: 'Bottom finish',
    bottomSeam: 'Bottom hem',
    chainProduct: 'Chain',
    chainSystem: 'Chain system',
    confirmPrint: 'Are you sure you want to print the ticket?',
    consumerName: 'Consumer name',
    cordProduct: 'Cord',
    createNewPrice: 'Create a customized price',
    createReturnOrder: 'Create return order',
    customerReference: 'Order number',
    customerRemarks: 'Customer remarks',
    cutSize: 'Cutting size (cm)',
    cutSizeLeft: 'Cutting size left (cm)',
    cutSizeRight: 'Cutting size right (cm)',
    deliver: 'Home delivery',
    delivery: 'Delivery',
    deliveryDate: 'Delivery date',
    details: 'Details',
    discount: 'Discount',
    discountPercentage: 'Discount percentage',
    embraceForOrderNumber: 'Embrace for',
    embraceFromFinish: 'Type',
    embraceFromOrderLine: 'Embrace',
    embraceFromOrderNumber: 'Embrace from',
    embraceHeight: 'Height (cm)',
    embraceLengthLeft: 'Length left (cm)',
    embraceLengthRight: 'Length right (cm)',
    equal: 'Equal',
    equalParts: 'Equal parts',
    estimatedDeliveryDate: 'Expected delivery date',
    exceedance: 'Exceedance',
    extras: 'Extras',
    fabricName: 'Fabric name',
    fabricStatus: 'Fabric status',
    fabricWidth: 'Fabric width (cm)',
    familyOrder: 'Family order',
    familyOrderLines: 'Orders',
    finishedWidth: 'Finished width (cm)',
    fixtureFinish: 'Fixture',
    fromStatus: 'From status',
    generalFinish: 'General finish',
    groupReference: 'Group reference',
    groupTotal: 'Group total',
    halfPanelFrom: 'Half panel from',
    halfPanelTo: 'Half panel to',
    headingHeight: 'Heading height (cm)',
    height: 'Finished height (cm)',
    highestInSet: 'Highest in set (cm)',
    length: 'Length (cm)',
    liningFabricProduct: 'Lining fabric',
    measurement: 'Measurement',
    metersAmountLeft: 'Meters left',
    metersAmountRight: 'Meters right',
    numberOfCords: 'Number of coords',
    numberOfHangers: 'Number of hangers',
    numberOfPanels: 'Number of panels',
    numberOfPanelsLeft: 'Panels left',
    numberOfPanelsRight: 'Panels right',
    numberOfParcels: 'Number of parcels',
    numberOfRibs: 'Number of ribs',
    numberOfSupports: 'Number of supports',
    operationSide: 'Operation side',
    orderDate: 'Order date',
    orderLinePriceType: 'Price type',
    orderLineStatus: 'Status',
    orderLineStatusChangedAt: 'Status changed at',
    orderLineSubstatus: 'Substatus',
    orderLinesCancelledLastMonth: 'Orders cancelled since last month',
    panelCustomerInfo: 'Customer',
    panelFabricInfo: 'Fabric info',
    panelFinish: 'Finish',
    panelGeneral: 'General',
    panelLiningFabricInfo: 'Lining info',
    panelStatus: 'Status',
    panelsForCreation: 'Total panels',
    parts: 'Parts',
    patternHeight: 'Pattern height (mm)',
    pickUp: 'Pick up',
    pickUpStore: 'Pick up location',
    pleatFactor: 'Pleating factor',
    priceRestricted: 'Price can not be changed since this ordes has already been invoiced.',
    prices: 'Prices',
    printProductionTicket: 'Print production ticket',
    printStatusOption: 'Print status',
    printStatusOptionFailed: 'Failed',
    printStatusOptionPrinted: 'Printed',
    printStatusOptionQueued: 'In queue',
    product: 'Product',
    productGroup: 'Product type',
    productionTicketPrinted: 'The production ticket has been sent to the printer',
    quantity: 'Quantity',
    railLength: 'Rail length (cm)',
    remarksOnTicket: 'Remarks on ticket',
    ribsEqual: 'Ribs equal',
    ribsSide: 'Ribs position',
    ribsType: 'Ribs',
    ringProduct: 'Ring',
    room: 'Room',
    sample: 'Sample',
    selectShipmentListDate: 'Select a date to see a list of ticket numbers with the status sending on that date',
    seriesNumber: 'Series',
    shareHalfPanelWith: 'Share panel with',
    shareHangerWith: 'Share hanger with',
    sharesHalfPanel: 'Shares half panel with this order',
    sharesHanger: 'Shares hanger with this order',
    shipmentListDate: 'Shipment date',
    show: 'Show',
    specials: 'Specials',
    standardOrder: 'Standard',
    status: 'Status',
    storeName: 'Store name',
    systemRemarks: 'System remarks',
    tabGeneral: 'General',
    tabHistory: 'History',
    tabPrices: 'Price',
    takeLeftoverFabric: 'Take leftover fabric',
    ticketNumber: 'Ticket number',
    ticketType: 'Ticket type',
    toShipmentList: 'Go to shipment list',
    toStatus: 'To status',
    topFinish: 'Top finish',
    topFinishHeight: 'Top finish height (cm)',
    totalAmount: 'Total',
    totalFabricInCm: 'Total fabric (cm)',
    transportEAN: 'Transport number',
    transportStatus: 'Transport status',
    transportStatusChangedAt: 'Date',
    unequal: 'Unequal',
    unequalParts: 'Unequal parts',
    urgent: 'Rush order',
    useExistingPrice: 'Use an existing price',
    validationMessage: 'Reason unprocessable',
    waveSize: 'Wave size (cm)',
    weights: 'Lead weights',
    width: 'Width (cm)',
    widthLeft: 'Width left (cm)',
    widthRight: 'Width right (cm)',
    workshop: 'Workshop'
  },
  orderLineStatus: {
    cancellationAllowed: 'Cancellation possible',
    changable: 'Changable',
    feedBack: 'Feed back client',
    orderLineStatus: 'Main status',
    orderLineSubstatus: 'Substatus',
    removeFromSeries: 'Remove from series',
    scanParameter: 'Scan parameter',
    settable: 'Settable',
    substatusOrder: 'Sequence',
    substatusOrderReserved: 'Number reserved'
  },
  orderLineStatusSummary: {
    fri: 'Fri',
    mon: 'Mon',
    sat: 'Sat',
    sun: 'Sun',
    thu: 'Thu',
    total: 'Total',
    tue: 'Tue',
    wed: 'Wed'
  },
  orderPick: {
    addFabric: 'Add fabric',
    comments: 'comments',
    location: 'location',
    neededMeters: 'needed meters',
    pickListID: 'List number',
    picked: 'Picked',
    pickedMeters: 'picked meters',
    pickedNumberOfRolls: 'picked no. of rolls',
    prefill: 'Pick needed m',
    processPickedItems: 'Save',
    productCode: 'art. no',
    productDescription: 'fabric name',
    selectAPickList: 'Enter a list number',
    seriesNumbers: 'Series numbers',
    widthInCm: 'width',
    yarnNumber: 'yarn no'
  },
  parcelType: {
    alternativeParcelType: 'Alternative parcel type',
    cuttingPackagesAndRoles: 'packages and roles',
    hangers: 'hangers',
    maximumLengthInM: 'Maximum length (m)',
    maximumQuantity: 'Maximum quantity',
    maximumWeightInKg: 'Maximum weight (kg)',
    parcelTypeOption: 'Parcel type',
    romanBlindBoxes: 'boxes'
  },
  penalty: {
    handedOutAtUtc: 'Handed out at (UTC)',
    penaltyPoints: 'Penalty points',
    penaltyType: 'Penalty type'
  },
  permission: {
    AccessLog: 'Access log',
    AppSetting: 'Appsettings',
    Ban: 'Bans',
    Client: 'Clients',
    ClientSalesReport: 'Client sales report',
    Collection: 'Fabric books',
    Company: 'Companies',
    Configuration: 'Settings',
    Country: 'Countries',
    Culture: 'Cultures',
    Currency: 'Currencies',
    DeliveryReport: 'Delivery report',
    DeliveryTimeReport: 'Delivery time report',
    Domain: 'Domains',
    DomainUser: 'Domain accounts',
    EventLog: 'Event log',
    ExactInstance: 'Exact instances',
    ExternalApiUser: 'External API users',
    ExternalInvoice: 'External invoices',
    Fabric: 'Fabrics',
    FabricOrder: 'Fabric orders',
    FabricReport: 'Fabric details',
    FabricStockReport: 'Stock reports',
    Finish: 'Finishes',
    FinishType: 'Finish types',
    GLAccount: 'General ledger accounts',
    HemaPendingProject: 'HEMA pending projects',
    InteriorDecorator: 'Interior decorators',
    InternalInvoice: 'Internal invoices',
    InvoiceSummary: 'Invoice summaries',
    Language: 'Languages',
    LinkDomainDeliveryPrice: 'Delivery prices',
    LinkPriceListItem: 'Link price list items',
    Option: 'Options',
    Order: 'Orders',
    OrderLineDeliveryDate: 'Order delivery date',
    OrderLinePrice: 'Order line prices',
    OrderLineStatus: 'Order statuses',
    OrderLineStatusSummary: 'Status summary dashboard',
    OrderPickList: 'Order pick lists',
    OrderReport: 'Datacomlist',
    OrderReportVolume: 'Order report volume',
    OrderedMetersReport: 'Ordered meters report',
    ParcelType: 'Parcel types',
    Permission: 'Permissions',
    PriceListItem: 'Price list items',
    PriceListItemPrice: 'Price list item prices',
    PriceListMatrix: 'Price list matrices',
    PrintTemplate: 'Print templates',
    Printer: 'Printers',
    PrinterClient: 'Printer clients',
    Product: 'Products',
    ProductGroup: 'Product groups',
    ProductType: 'Product types',
    ProductionPlanning: 'Create selections',
    ProductionPlanningSeries: 'Production series',
    QueuedKwantumOrder: 'Kwantum orders',
    ReasonStockCorrection: 'Reasons stock correction',
    ReturnCause: 'Return causes',
    ReturnReason: 'Return types',
    ReturnReasonCategory: 'Return type categories',
    ReturnReport: 'Return report',
    Role: 'Roles',
    SetStockTask: 'Recalculate available stock based on orders',
    Shipment: 'Transport orders',
    ShipmentListToBlackHole: 'Send shipment list to black hole',
    ShipmentListType: 'Shipment list types',
    Special: 'Specials',
    StandardUser: 'Standard users',
    Stock: 'Stock',
    StockCorrection: 'Stock corrections',
    StockLocation: 'Stock locations',
    Store: 'Stores',
    StoreAttribute: 'Store attributes',
    StoreFabric: 'Store fabrics',
    StoreType: 'Store types',
    StoreUser: 'Store user accounts',
    Supplier: 'Suppliers',
    TemplateImage: 'Template images',
    Translation: 'Translations',
    TransportCompany: 'Transport companies',
    TransportOrder: 'Shipments',
    TransportRoute: 'Transport routes',
    Truck: 'Trucks',
    Unit: 'Units',
    User: 'Users',
    VatType: 'VAT types',
    Workshop: 'Workshop',
    Yarn: 'Yarn',
    execute: 'Execute',
    none: 'None',
    pageIsReadonly: 'You are not allowed to edit this page.',
    read: 'Read',
    roles: 'Your roles',
    selectPlaceholder: 'Select the access level',
    switchRoles: 'Switch roles',
    tabPermissions: 'Permissions',
    tabTaskTypes: 'Task Types',
    write: 'Write'
  },
  pickrec: {
    chooseEntryFor: 'Choose "{caption}"',
    itemNotFound: "'{caption}' not found",
    suggestionsMayBeMore: 'There are possibly more search hits',
    suggestionsRestCount: 'There are {count} more search hits'
  },
  planning: {
    alreadyPlanned: 'A planning for this product group has already been made within the current production planning.',
    amount: 'Amount',
    basedOnOrderDate: 'Using order date',
    capacity: 'Capacity',
    capacityRequired: 'Capaciteit is vereisd',
    capacityStep: 'Enter Capacity',
    confirmYear: 'Start production planning for',
    considerStoreAttributes: 'Series by store attribute',
    curtainsMeters: 'meters ceiling high',
    curtainsRoomHigh: 'Ceiling high',
    cuttings: 'Coupages',
    distributionCenterAvailableAmountInMeters: 'D.C. stock (m)',
    domainAvailableAmountInMeters: 'total stock (m)',
    estimatedDeliveryDate: 'Estimated delivery date',
    excludeDiverseLining: 'Exclude diverse lining',
    excludedFabricsWillBeIgnored: 'Excluded fabrics will be ignored (configured in the workshop)',
    excludedStoreAttributes: 'Excluded store attributes',
    excludedStores: 'Excluded stores',
    exportSelection: 'Export selections',
    fabricCode: 'Code',
    fabricDescription: 'Fabric',
    generate: 'Generate',
    group: 'Group',
    inefficientPlanning: 'This will result in an inefficient planning',
    installationService: 'Installation service',
    makeCurrent: 'Start planning',
    makeSelection: 'Make selection',
    makeSeries: 'Make series',
    meters: 'Meters',
    netCurtainsMeters: 'meters laces',
    netCurtainsRoomHigh: 'Laces',
    newProposalWithFilter: 'New proposal with filter',
    noStock: 'No stock',
    oldestOrder: 'Oldest order',
    orderAmount: 'Amount of orders',
    orders: 'Number of family orders',
    ordersToPlan: 'Orders to plan',
    panels: 'Panels',
    pieces: 'Pieces',
    plan: 'Plan',
    planAgain: 'Plan again',
    planningDateRange: 'This planning contains orders between the following dates',
    planningInProgress: 'A planning is already in progress in the week of ',
    preselectionMade:
      "A selection for this group is already in progress. Click 'plan' to continue this selection, click 'reset group' to start over.",
    requiredCapacity: 'Required capacity',
    requiredFabric: 'Required fabric (m)',
    reset: 'Reset group',
    romanBlinds: 'Blinds',
    samples: 'Only samples',
    selectionStep: 'Create Selections',
    series: 'Series',
    seriesNumber: 'Serial number',
    seriesStep: 'Create Series',
    storeAttribute: 'Store attribute',
    strictlySelectedYarns: 'Only selected yarns',
    tabGeneral: 'Capacity planning',
    temporarySave: 'Save temporarily',
    tickets: 'Tickets',
    toPlan: 'To plan',
    weekNumber: 'Week number',
    workshopAvailableAmountInMeters: 'Workshop stock (m)',
    workshopID: 'Workshop',
    workshopOrder: '#',
    yarnDescription: 'Yarn'
  },
  planningOption: {
    CurtainRoomHigh: 'Ceiling high',
    CurtainRoomHighUnit: 'meters',
    Cutting: 'Cutting',
    CuttingUnit: 'pieces',
    NetCurtainRoomHigh: 'Laces',
    NetCurtainRoomHighUnit: 'meters',
    Panel: 'Panels',
    PanelUnit: 'panels',
    RomanBlind: 'Roman blinds',
    RomanBlindUnit: 'pieces',
    Tieback: 'Tiebacks',
    TiebackUnit: 'pieces'
  },
  priceListItem: {
    currentPrice: 'Current price',
    descriptionInvoice: 'Invoice description',
    descriptionInvoiceForeign: 'Invoice description international',
    externalOnlyYN: 'On internal invoice',
    gtinNumber: 'GTIN-number',
    height: 'Height',
    intercompany: 'IC',
    laborPrice: 'Labor price',
    markUpType: 'Markup type',
    markUpYN: 'Markup',
    matrixYN: 'Matrix',
    maximumLength: 'Maximum height',
    maximumWidth: 'Maximum width',
    minimumLength: 'Minimum height',
    minimumWidth: 'Minimum width',
    newPrice: 'New price',
    nextPrice: 'Next price',
    priceListItems: 'Price list items',
    productCode: 'Product code',
    stepSizeLength: 'Stepsize height',
    stepSizeWidth: 'Stepsize width',
    tabCountryMatrix: 'Price matrix workshops',
    tabGeneral: 'General',
    tabMatrix: 'Price matrix',
    tabPrices: 'Price list',
    unit: 'Unit',
    width: 'Width'
  },
  priceListItemPrice: {
    calculatePrices: 'Calculate prices',
    consumerPrice: 'Consumer price',
    consumerPrices: 'Consumer prices',
    currency: 'Currency',
    effectiveDate: 'Effective date',
    expirationDate: 'Expiration date',
    laborPrice: 'Labor price',
    priceType: 'Price type',
    rounding: 'Rounding',
    showPrices: 'Show prices',
    workshopPrices: 'Workshop prices'
  },
  printTemplate: {
    domains: 'Domains',
    productGroup: 'Product group',
    templateDocument: 'File name',
    versionNumber: 'Version'
  },
  printer: {
    printProvider: 'Provider',
    statusOption: 'Status',
    statusReceivedAt: 'Status received on',
    statusText: 'Received status',
    typeOption: 'Printer type'
  },
  product: {
    measurementInMm: 'Measurement (mm)',
    ownCode: 'Own code',
    ownProduct: 'Own product',
    printOnTicket: 'Print on ticket',
    stockItem: 'Stock item'
  },
  productGroup: {
    active: 'Active',
    addWeights: 'Add weights',
    defaultFinishQuantityFormula: 'Default formula for amount (from finish)',
    description: 'Description',
    finishTypes: 'Finish types',
    maximumFabricWidthInCm: 'Maximum fabric width unlined (cm)',
    maximumHeightInCm: 'Maximum height unlined (cm)',
    maximumLinedFabricWidthInCm: 'Maximum lined fabric width (cm)',
    maximumLinedHeightInCm: 'Maximum height lined (cm)',
    maximumLinedWidthInCm: 'Maximum width lined (cm)',
    maximumNumberOfLinedPanels: 'Maximum number of lined panels',
    maximumNumberOfPanels: 'Maximum number of panels unlined',
    maximumWidthInCm: 'Maximum width unlined (cm)',
    minimumHeightInCm: 'Minimum height (cm)',
    minimumNumberOfPanels: 'Minimum number of panels',
    minimumWidthInCm: 'Minimum width (cm)',
    parcelType: 'Parcel type',
    productGroupTypeOption: 'Calculations according to',
    productGroups: 'Product groups',
    shipmentListType: 'Shipment list type',
    tabPossibleFabricProductTypes: 'Possible fabrics',
    tabPossibleFinishes: 'Possible finishes'
  },
  productType: {
    fabricTypeOption: 'Fabric type',
    measurementRequiredYN: 'Measurement required',
    products: 'Products',
    velours: 'Velours'
  },
  reasonStockCorrection: {
    reasonStockCorrectionOption: 'Category'
  },
  report: {
    deliveryReport: 'Delivery report',
    export: 'Export list',
    orderReport: 'Order report'
  },
  request: {
    networkError: 'Network can not be reached.'
  },
  return: {
    return: 'Return',
    returnCause: 'Return cause',
    returnPriceListItem: 'Price to link',
    returnReason: 'Return reason',
    returnReasonCategory: 'Return reason category',
    returnReasonCategoryCode: 'Report number',
    returnReasonCharacter: 'Report character',
    returnReasons: 'Return reasons',
    returnType: 'Returntype'
  },
  route: {
    Table: 'Table',
    avatarUpload: 'Avatar Upload',
    clipboardDemo: 'Clipboard',
    complexTable: 'Complex Table',
    componentIndex: 'Introduction',
    componentMixin: 'Mixin',
    components: 'Components',
    countTo: 'CountTo',
    createClient: 'Create client',
    createCollection: 'Create fabric book',
    createCompany: 'Create a company',
    createContactPerson: 'Create a contact person',
    createCountry: 'Create country',
    createCulture: 'Create a culture',
    createCurrency: 'Create a currency',
    createDomain: 'Create domain',
    createDomainUser: 'Create domain account',
    createExactInstance: 'Create Exact instance',
    createExternalApiUser: 'Create external API user',
    createFabric: 'Create a fabric',
    createFabricOrder: 'Create a fabric order',
    createFabricOrderLine: 'Create fabric order line',
    createFinish: 'Create finish',
    createFinishType: 'Create finish type',
    createInteriorDecorator: 'Create interior decorator',
    createInvalidFinishCombination: 'Create invalid finish combination',
    createLanguage: 'Create language',
    createLinkDomainDeliveryPrice: 'Create a delivery price',
    createLinkDomainProductGroup: 'Create domain productgroup link',
    createLinkDomainProductGroupFinish: 'Create customer-specific finish',
    createLinkPriceListItem: 'Create a link price list item',
    createLinkReasonStockCorrectionDomain: 'Create domain link',
    createOrder: 'Create order',
    createOrderLine: 'Create order',
    createOrderLinePrice: 'Create order line price',
    createOrderLineStatus: 'Create order status',
    createParcelType: 'Create a parcel type',
    createPriceListItem: 'Create a price list item',
    createPriceListItemPrice: 'Create a price list item price',
    createPriceListMatrix: 'Create a price list matrix',
    createPrintTemplate: 'Create template',
    createPrinter: 'Create printer',
    createPrinterClient: 'Create a printer client',
    createProduct: 'Create product',
    createProductGroup: 'Create product group',
    createProductType: 'Create product type',
    createProductionPlanning: 'Create a selection',
    createQueuedKwantumOrder: 'Create a kwantum order',
    createReasonStockCorrection: 'Create reason for stock correction',
    createReturnCause: 'Create a return cause',
    createReturnReason: 'Create a return type',
    createReturnReasonCategory: 'Create a return type category',
    createRole: 'Create a role',
    createShipmentListType: 'Create a shipment list type',
    createSpecial: 'Create a special',
    createStandardUser: 'Create user',
    createStock: 'Create a stock',
    createStockLocation: 'Create stock location',
    createStore: 'Create store',
    createStoreAttribute: 'Create attribute',
    createStoreType: 'Create a store type',
    createSupplier: 'Create supplier',
    createTemplateImage: 'Create ticket pictogram',
    createTransportCompany: 'Create a transport company',
    createTransportRoute: 'Create a transport route',
    createTruck: 'Create a truck',
    createUnit: 'Create unit',
    createUrgentSeries: 'Create rush series',
    createUser: 'Create a user',
    createVatType: 'Create VAT type',
    createVatTypeRate: 'Create a VAT rate',
    createWorkshop: 'Create a workshop',
    createYarn: 'Create yarn',
    createglAccount: 'Create a general ledger account number',
    customTreeTable: 'Custom TreeTable',
    dashboard: 'Dashboard',
    directivePermission: 'Directive Permission',
    documentation: 'Documentation',
    dragDialog: 'Drag Dialog',
    dragTable: 'Drag Table',
    dropzone: 'Dropzone',
    dynamicTable: 'Dynamic Table',
    editClient: 'Edit client',
    editCollection: 'Edit fabric book',
    editCompany: 'Edit company',
    editConfiguration: 'Edit setting',
    editContactPerson: 'Edit contact person',
    editCountry: 'Edit country',
    editCulture: 'Edit culture',
    editCurrency: 'Edit currency',
    editDomain: 'Edit domain',
    editDomainUser: 'Edit domain account',
    editExactInstance: 'Edit Exact instance',
    editExternalApiUser: 'Edit external API user',
    editFabric: 'Edit fabric',
    editFabricOrder: 'Edit fabric order',
    editFabricOrderLine: 'Edit fabric order line',
    editFabricRolls: 'Edit fabric rolls',
    editFinish: 'Edit finish',
    editFinishType: 'Edit finish type',
    editInteriorDecorator: 'Edit interior decorator',
    editInvalidFinishCombination: 'Edit invalid finish combination',
    editLanguage: 'Edit language',
    editLinkDomainDeliveryPrice: 'Edit delivery price',
    editLinkDomainProductGroup: 'Edit domain productgroup link',
    editLinkDomainProductGroupFinish: 'Edit customer-specific finish',
    editLinkPriceListItem: 'Edit link price list item',
    editLinkReasonStockCorrectionDomain: 'Edit domain link',
    editOrder: 'Edit order',
    editOrderLine: 'Edit order',
    editOrderLinePrice: 'Edit order line price',
    editOrderLineStatus: 'Edit order status',
    editOrderPickList: 'Edit order pick list',
    editParcelType: 'Edit parcel type',
    editPriceListItem: 'Edit price list item',
    editPriceListItemPrice: 'Edit price list item price',
    editPriceListMatrix: 'Edit price list matrix',
    editPrintTemplate: 'Edit template',
    editPrinter: 'Edit printer',
    editPrinterClient: 'Edit printer client',
    editProduct: 'Edit product',
    editProductGroup: 'Edit product group',
    editProductType: 'Edit product type',
    editProductionPlanning: 'Edit selection',
    editQueuedKwantumOrder: 'Edit kwantum order',
    editReasonStockCorrection: 'Edit reason for stock correction',
    editReturnCause: 'Edit return cause',
    editReturnReason: 'Edit return type',
    editReturnReasonCategory: 'Edit return type category',
    editRole: 'Edit role',
    editSeries: 'Edit series',
    editShipmentListType: 'Edit shipment list type',
    editSpecial: 'Edit special',
    editStandardUser: 'Edit user',
    editStock: 'Edit stock',
    editStockLocation: 'Edit stock location',
    editStore: 'Edit store',
    editStoreAttribute: 'Edit attribute',
    editStoreType: 'Edit store type',
    editStoreUser: 'Edit user',
    editSupplier: 'Edit supplier',
    editTemplateImage: 'Edit ticket pictogram',
    editTranslation: 'Edit translation',
    editTransportCompany: 'Edit transport company',
    editTransportOrder: 'Edit shipment list',
    editTransportRoute: 'Edit transport route',
    editTruck: 'Edit truck',
    editUnit: 'Edit unit',
    editUser: 'Edit user',
    editVatType: 'Edit VAT type',
    editVatTypeRate: 'Edit VAT rate',
    editWorkshop: 'Edit workshop',
    editYarn: 'Edit yarn',
    editglAccount: 'Edit general ledger account number',
    errorLog: 'Error Log',
    errorPages: 'Error Pages',
    example: 'Example',
    excel: 'Excel',
    exportExcel: 'Export Excel',
    exportZip: 'Export Zip',
    externalLink: 'External Link',
    form: 'Form',
    guide: 'Guide',
    home: 'Home',
    i18n: 'I18n',
    icons: 'Icons',
    inlineEditTable: 'Inline Edit',
    introduction: 'Introduction',
    jsonEditor: 'JSON Editor',
    markdown: 'Markdown',
    menu_admin: 'Administrator',
    menu_admin_accesslog: 'Access Log',
    menu_admin_application: 'Application',
    menu_admin_appsettings: 'Appsettings',
    menu_admin_bans: 'Bans',
    menu_admin_collections: 'Fabric books',
    menu_admin_company_structure: 'Organizational structure',
    menu_admin_configuration: 'Settings',
    menu_admin_countries: 'Countries',
    menu_admin_domain_users: 'Domain accounts',
    menu_admin_eventlog: 'Event Log',
    menu_admin_exact_instances: 'Exact instances',
    menu_admin_external_api_users: 'External API logins',
    menu_admin_fabric_order: 'Fabric orders',
    menu_admin_fabrics: 'Fabrics list',
    menu_admin_finishtypes: 'Finishes',
    menu_admin_interior_decorators: 'Interior decorators',
    menu_admin_invoicing: 'Invoicing',
    menu_admin_languages: 'Languages',
    menu_admin_masterdata: 'Master data',
    menu_admin_options: 'Options lists',
    menu_admin_ordering_api_users: 'Ordering API logins',
    menu_admin_penalties: 'Penalties',
    menu_admin_pricing: 'Pricing',
    menu_admin_printtemplates: 'Templates order tickets',
    menu_admin_productgroups: 'Product groups',
    menu_admin_production: 'Production',
    menu_admin_producttypes: 'Products',
    menu_admin_reasonstockcorrections: 'Reason stock corrections',
    menu_admin_roles: 'Roles',
    menu_admin_store_users: 'Stores',
    menu_admin_templateimages: 'Ticket pictograms',
    menu_admin_translations: 'Translation',
    menu_admin_transport: 'Transport',
    menu_admin_units: 'Units',
    menu_admin_users: 'Users',
    menu_admin_vattypes: 'VAT types',
    menu_admin_yarns: 'Yarn',
    menu_client_management: 'Customer management',
    menu_client_sales_report: 'Client sales report',
    menu_clients: 'Customers',
    menu_companies: 'Companies',
    menu_component_list: 'Component list',
    menu_cultures: 'Cultures',
    menu_currencies: 'Currencies',
    menu_delivery_report: 'Delivery report',
    menu_delivery_time_report: 'Delivery time',
    menu_domains: 'Domains',
    menu_external_invoices: 'External invoices',
    menu_fabric_inventory: 'Inventory',
    menu_fabric_management: 'Fabrics',
    menu_fabric_report: 'Fabric details',
    menu_fabric_stockcorrections: 'Stock correction',
    menu_fabric_stockreport: 'Stock report',
    menu_hema: 'HEMA',
    menu_internal_invoices: 'Internal invoices',
    menu_invoice_summary: 'Invoice summary',
    menu_invoicing: 'Invoicing',
    menu_link_domain_delivery_prices: 'Delivery Prices',
    menu_link_price_list_items: 'Link Price List Items',
    menu_matrix_prices: 'Matrix prices',
    menu_order_drafts: 'Drafts',
    menu_order_handling: 'Orders',
    menu_order_line_prices: 'Order Line Prices',
    menu_order_line_statuses: 'Order statuses',
    menu_order_pick_list: 'Create order pick list',
    menu_order_pick_list_complete: 'Sent order pick list',
    menu_order_report: 'Datacomlist',
    menu_order_report_volume: 'Order report volume',
    menu_ordered_meters_report: 'Ordered meters',
    menu_orderlines: 'Orders',
    menu_orders: 'Order list',
    menu_parcel_types: 'Parcel Types',
    menu_planning: 'Planning',
    menu_price_list_item_prices: 'Price List Item Prices',
    menu_price_list_items: 'Price List Items',
    menu_price_list_matrices: 'Price List Matrices',
    menu_printer_clients: 'Printer Clients',
    menu_production_planning: 'Selection',
    menu_queued_kwantum_orders: 'Kwantum Orders',
    menu_reports: 'Report',
    menu_return_causes: 'Return Causes',
    menu_return_report: 'Return report',
    menu_return_type_categories: 'Return Type Categories',
    menu_return_types: 'Return Types',
    menu_series: 'Series',
    menu_shipment_list_types: 'Shipment List Types',
    menu_show_orders: 'Show samples',
    menu_specials: 'Specials',
    menu_status_list: 'Status list',
    menu_store: 'Store',
    menu_store_fabrics: 'Fabrics',
    menu_store_orders: 'Orders',
    menu_store_shipment_list: 'Shipment list',
    menu_stores: 'Stores',
    menu_suppliers: 'Suppliers',
    menu_transport: 'Transport',
    menu_transport_companies: 'Transport Companies',
    menu_transport_list: 'Shipment lists',
    menu_transport_planning: 'Create shipment lists',
    menu_transport_routes: 'Transport Routes',
    menu_trucks: 'Trucks',
    menu_workshops: 'Workshops',
    page401: '401',
    page403: '403',
    page404: '404',
    pagePermission: 'Page Permission',
    permission: 'Permission',
    selectExcel: 'Export Selected',
    splitPane: 'SplitPane',
    sticky: 'Sticky',
    tab: 'Tab',
    theme: 'Theme',
    tinymce: 'Tinymce',
    treeTable: 'Tree Table',
    uploadExcel: 'Upload Excel',
    userSettings: 'User settings',
    zip: 'Zip'
  },
  series: {
    addOrderNumber: 'Add order number',
    addOrderNumbers: 'Add order numbers',
    amount: 'Amount',
    amountOfEmbraces: 'Tiebacks',
    amountOfHangers: 'Hangers',
    amountOfOrderLines: 'Orders',
    amountOfOrders: 'Familyorders',
    amountOfParcels: 'Parcels',
    amountOfRings: 'Rings',
    amountOfWaves: 'Wavepleats',
    bulkActionLabel: 'Change selected orders',
    confirmDelete: 'Are you sure you want to remove the selected orders from the series?',
    confirmPrint: 'Are you sure you want to print the selected tickets?',
    confirmUpdate: 'Are you sure you want to update the selected orders?',
    domainName: 'Domain',
    doubleOrderNumber: 'Double order number',
    numberOfMeters: 'Meters',
    numberOfPanels: 'Panels',
    orderNumbersAdded: 'Order numbers added',
    orderNumbersNotAdded: 'Order numbers could not be added',
    pieces: 'Pieces',
    printTickets: 'Print tickets',
    quantity: 'Quantity',
    series: 'Series',
    seriesDescription: 'Series',
    seriesNumber: 'Number',
    seriesPrintError: 'Not all tickets could be printed',
    seriesPrintStart: '{toBePrintedCount} tickets from this series are printed',
    seriesPrintSuccess: 'The tickets were sent to {printDestination}',
    seriesStatus: 'Status',
    ticketsAlreadyPrintedCancel: 'Yes, reprint',
    ticketsAlreadyPrintedConfirm: 'No, cancel',
    ticketsAlreadyPrintedMessage:
      '{printedTickets} of {totalTickets} have already been printed. Do you want to reprint it?',
    ticketsAlreadyPrintedTitle: 'Warning',
    typeOfOrders: 'Type of orders',
    unit: 'Unit',
    updateOrderLines: 'Update',
    weekNumber: 'Week',
    workshopName: 'Workshop'
  },
  size: {
    medium: 'Medium',
    mini: 'Mini',
    small: 'Small'
  },
  special: {
    descriptionOnTicket: 'Description ticket',
    specialType: 'Special type'
  },
  statusList: {
    allOrders: 'All orders',
    fabricCode: 'Article number',
    fabricName: 'Fabric name',
    hangers: 'Hangers',
    notScanned: 'Not scanned',
    scanned: 'Scanned',
    seriesNumber: 'Series',
    seriesPlaceholder: 'Series numbers [1-5,7,10-12]',
    status: 'Status',
    storeCode: 'Store number',
    storeName: 'Store name',
    subStatus: 'Substatus',
    ticketNumber: 'Ticket number'
  },
  stock: {
    mutatedAt: 'Booking date',
    mutationInMeters: 'Meters',
    mutationReason: 'Reason',
    onlyShowFabricsWithAvailableStock: 'Only show fabrics with available stock',
    positionCode: 'Location code',
    stockAvailable: 'Available stock (m)',
    stockBlocked: 'Blocked stock (m)',
    stockLocationName: 'Voorraadlocatie',
    stockReserved: 'Work in progress (m)',
    stockSold: 'Sold stock (m)'
  },
  stockCorrection: {
    availableAmount: 'Available stock (m)',
    chooseReasonStockCorrection: 'Reason stock correction',
    clearInput: 'Clear input',
    clearInputSuggestion: 'Please process or clear your input before changing the stock list',
    clearInputWarning: 'All your input will be cleared',
    correction: 'Correction (m)',
    createdAt: 'Booking date',
    mutation: 'Booking (m)',
    noInput: 'No corrections have been entered',
    processStockCorrection: 'Process stock corrections',
    reason: 'Reason',
    reasonRequired: 'A reason is required',
    remarks: 'Remark',
    saveSelection: 'Save correction',
    selectAStockLocation: 'Select a stock location and correction reason',
    selectTransferLocation: 'Select a stock location to transfer to',
    setStock: 'Recalculate available stock based on orders',
    stockLocationName: 'Stock location',
    stockProductCode: 'Code',
    stockProductDescription: 'Fabric',
    targetStockLocation: 'Transfer to',
    transferToSameLocationError: 'The current location is the same as the transfer location'
  },
  store: {
    attribute: 'Attribute',
    code: 'Store number',
    collection: 'Collection',
    consumerOrderTicketURL: 'URL for creating consumer ticket',
    domain: 'Domain',
    height: 'Height (cm)',
    name: 'Store name',
    noConsumerOrderTicketURLConfigured: 'Unable to show customer ticket. Please contact Content',
    tabContactPersons: 'Contact persons',
    tabGeneral: 'General',
    tabSettings: 'Settings',
    tabStoreCollections: 'Collections',
    type: 'Store type'
  },
  storeFabric: {
    availableStockInM: 'Stock (m)',
    estimatedNewStock: 'Estimated new stock',
    soldStockInM: 'Sold (m)'
  },
  storeUser: {
    clientName: 'Client',
    storeCode: 'Store number',
    storeName: 'Store'
  },
  supplier: {
    agentName: 'Agent name',
    code: 'Supplier number',
    domain: 'Domain',
    tabContactPersons: 'Contact persons',
    tabGeneral: 'General'
  },
  table: {
    actions: 'Actions',
    searchDatePlaceholder: 'Type or select',
    searchPlaceholder: 'Type to search',
    searchSelectPlaceholder: 'Select to search',
    withRestriction: 'With restriction'
  },
  tagsView: {
    close: 'Close',
    closeAll: 'Close All',
    closeOthers: 'Close Others',
    refresh: 'Refresh'
  },
  templateImage: {
    templateDocument: 'Image (png)',
    templateImageTypeOption: 'Pictogram type'
  },
  translation: {
    code: 'Translation code'
  },
  transport: {
    loadingAddress: 'Loading address',
    loadingAddressCode: 'Loading address code',
    loadingTimeRange: 'Loading times (from, until)',
    parcelTypes: 'Parcel types',
    shipperNumber: 'Shipper number store delivery',
    shipperNumberHomeDelivery: 'Shipper number home delivery',
    transportCompany: 'Transport company',
    unloadingAddressCode: 'Unloading address code',
    unloadingTimeRange: 'Unloading times (from, until)'
  },
  transportOrder: {
    confirmAlreadyExportedExport: 'This shipment list has already been sent. Do you want to send it again?',
    confirmExport: 'Do you want to send this shipment list to the transport company?',
    confirmExportToBlackHole: 'Send shipping list to black hole?',
    confirmFixDeliveryDate: 'Do you want to update the delivery date of all orders on this shipping list?',
    countryCode: 'Country',
    createShipments: 'Create shipments',
    domainOrderNumberPrefix: 'Domain',
    exportShipments: 'Send to shipping company',
    exportedAt: 'Shipment list sent',
    exportedTo: 'To',
    fromDate: 'Orders from',
    hangers: 'Hangers',
    isExcluded: 'Will NOT be shipped',
    isIncluded: 'Will be shipped',
    parcels: 'Hangers/parcels',
    planningDateRange: 'This list contains orders scanned between the following dates',
    reference: 'Reference',
    scannedAt: 'Scan date/time',
    seriesNumber: 'Series',
    shipmentAt: 'Transport date/time',
    shipmentListTypeName: 'Shipment list type',
    shipments: 'Shipments',
    shipmentsCreated: 'The shipment lists are created',
    shipmentsExportError: 'The shipment list could not be sent to the shipping company',
    shipmentsExported: 'The shipment list has been sent to the shipping company',
    status: 'Status',
    storeAttribute: 'Store attribute',
    storeCode: 'Store number',
    subStatus: 'Substatus',
    ticketNumber: 'Ticket',
    truckIdentifier: 'Truck',
    untilDate: 'Orders until',
    updateOrder: 'Update orders',
    workshops: 'Workshop(s)'
  },
  transportRoute: {
    code: 'Route code',
    countryCode: 'Country',
    postalCodeFrom: 'Postal code From',
    postalCodeTo: 'Postal code To'
  },
  unit: {
    meters: 'meters',
    panels: 'panels',
    pieces: 'pieces'
  },
  user: {
    avatar: 'Profile picture',
    avatarInfo: 'URL to profile picture',
    newPassword: 'New password',
    newPasswordInfo: "Leave empty when you don't want to change your password",
    oldPassword: 'Current password',
    oldPasswordInfo: 'Enter your current password for verification',
    oldPasswordInvalid: 'You did not enter the correct current password',
    passwordChanged: 'Your password has been changed',
    repeatPassword: 'Repeat password',
    repeatPasswordInfo: 'Repeat your new password for verification',
    roles: 'Roles',
    workingAt: 'Working at'
  },
  validation: {
    cannotExcludePreferredWorkshop: 'Cannot exclude preferred workshop',
    complexity: 'Choose complexity',
    countryRequiredForDelivery: 'Country is required for home delivery',
    ean: 'This barcode is incorrect',
    email: 'This is an invalid e-mail address',
    error: {
      alphanumeric: 'Password must contain a symbol',
      digit: 'Password must contain a digit',
      invalidFormula: 'One or more formulas contains an error: {errorMessage}',
      isFromDatabase: 'Could not validate your password, because the server could not be reached.',
      itemNotFound: 'Item not found.',
      length: 'Password must contain at least {count} characters',
      lowercase: 'Password must contain a lowercase character',
      passwordComplexity: 'The password does not meet the required complexity',
      uppercase: 'Password must contain an uppercase character'
    },
    formValidationFailed: 'This form has errors. Please review your input and retry',
    notAllWorkshopsCanBeExcluded: 'At least 1 workshop must be available',
    numeric: 'Only numbers allowed',
    oldPasswordRequired: 'Please input the old password',
    repeatPasswordMismatch: "Two inputs don't match",
    required: 'This field is required'
  },
  vat: {
    countryCode: 'Country',
    countryID: 'Country',
    glCodePurchase: 'G/L code purchase',
    glCodeSales: 'G/L code sales',
    invoiceText: 'Text on invoice',
    rates: 'Rates',
    startDate: 'From',
    taxCategoryCode: 'UNECE code',
    vatNumber: 'VAT id',
    vatNumberRequiredYN: 'VAT number required',
    vatPercentage: 'Rate (%)',
    vatType: 'VAT type',
    vatTypeOption: 'Type'
  },
  wizard: {
    next: 'Next',
    prev: 'Previous',
    skip: 'Skip',
    skipnexttwo: 'Skip two'
  },
  workshop: {
    code: 'Workshop number',
    excludeExpressOrderYN: ' Exclude express orders',
    excludeHandlockYN: 'Exclude handlock',
    excludeSamplesYN: ' Exclude samples',
    ignoreExcludedFabrics: 'Ignore excluded fabrics',
    maximumProcessingHeight: 'Maximale processing height (cm)',
    metersMaxPerSeries: 'Meters per series',
    panelsMaxPerSeries: 'Panels per series',
    planningDisabled: 'Planning disabled',
    romanBlindsMaxPerSeries: 'Roman blinds per series',
    stockLocationName: 'Stock location name'
  },
  yarn: {
    planningOrder: 'Planning order'
  }
};
